module.exports = __webpack_public_path__ + "img/90effective.b6e054ea.png";